import TextNode from './TextNode'

class TextBlock extends TextNode {}

TextBlock.isBlock = true

export default TextBlock
